<div class="close-container">
  <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
</div>
<div mat-dialog-title class="mat-dialog-title">Update discount code</div>

<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">

  <mat-dialog-content class="mat-dialog-content">

    <label for="discountCode">Discount Code</label>
    <input type="text" formControlName="discountCode" class="form-control" [required]="true">

    <label for="memberGroups">Member Groups</label>
    <mat-select required [(value)]="selectedMemberGroups"  multiple disableRipple
      formControlName="memberGroups" panelClass="mat-panel">
      <mat-option *ngFor="let memberGroup of memberGroupsOptions"[value]="memberGroup">
        {{memberGroup}}
      </mat-option>
    </mat-select>

    <label for="beginDate">Begin Date</label>
    <div class="dateContainer">
      <div (click)="beginDateDatePicker.open()" class="" class="date--form-control">
        <input [matDatepicker]="beginDateDatePicker" formControlName="beginDate" required="true" [readonly]="true"
          class="form-control">
      </div>
      <mat-datepicker-toggle [for]="beginDateDatePicker"></mat-datepicker-toggle>
      <mat-datepicker disabled="false" required="true" #beginDateDatePicker ngDefaultControl>
      </mat-datepicker>
      <!-- <div class="required-text" *ngIf="invalidRequiredField('beginDate') || invalidDateField()" >Begin Date is required and must be
        precede the End Date
      </div> -->
    </div>
    <label for="endDate">End Date</label>
    <div class="dateContainer">
      <div (click)="endDateDatePicker.open()" class="" class="date--form-control">
        <input [matDatepicker]="endDateDatePicker" formControlName="endDate" required="true" [readonly]="true"
          class="form-control">
      </div>
      <mat-datepicker-toggle [for]="endDateDatePicker"></mat-datepicker-toggle>
      <mat-datepicker required="true" #endDateDatePicker ngDefaultControl>
      </mat-datepicker>
    </div>

    <label for="flatDiscount">Flat Discount</label>
    <input type="text" formControlName="flatDiscount" class="form-control">
      <mat-error *ngIf="this.formGroup.get('flatDiscount').hasError('numbersOnly')">
        {{this.formGroup.get('flatDiscount').getError('numbersOnly')}}
      </mat-error>

    <label for="percentDiscount">Percent Discount</label>
    <input type="text" formControlName="discountPercent" class="form-control">
    <mat-error *ngIf="this.formGroup.get('discountPercent').hasError('numbersOnly')">
      {{this.formGroup.get('discountPercent').getError('numbersOnly')}}
    </mat-error>

    <label for="description">Description</label>
    <textarea class="form-control" id="description" formControlName="description" [required]="true" matInput rows="5"
      cols="40"></textarea>

  </mat-dialog-content>
  <mat-dialog-actions class="dialog-btn-container">
    <button type=submit [disabled]="!formGroup.valid" class="btn btn--red btn--solid btn--inline ">Update</button>
  </mat-dialog-actions>
</form>
<app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>